export default {"src":"/_next/static/media/gleec-logo.33f61dac.svg","height":28,"width":144,"blurWidth":0,"blurHeight":0};